export default "__VITE_ASSET__DYSg7HLa__"